/**
 * Google Analytics 4 ユーティリティ
 *
 * GA4 のタグは index.html で読み込まれており、
 * このモジュールは gtag 関数のラッパーを提供する
 */

// GA4 Measurement ID
const GA_MEASUREMENT_ID = 'G-LE7PCBPMS9';

// gtag の型定義
declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

/**
 * gtag が利用可能かどうかを確認
 */
function isGtagAvailable(): boolean {
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
}

/**
 * ユーザーID を GA4 に設定
 * 認証成功時に呼び出す
 *
 * @param userId - ラクスルユーザーID
 */
export function setAnalyticsUserId(userId: string): void {
  if (!isGtagAvailable()) {
    console.warn('[Analytics] gtag is not available');
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    user_id: userId,
  });

  // user_properties としても設定（レポートで使いやすい）
  // 注意: GA4 では user_id は予約済みのため、カスタムディメンションには raksul_id を使用
  window.gtag('set', 'user_properties', {
    raksul_id: userId,
  });
}

/**
 * ユーザーID をクリア
 * ログアウト時に呼び出す
 */
export function clearAnalyticsUserId(): void {
  if (!isGtagAvailable()) {
    return;
  }

  window.gtag('config', GA_MEASUREMENT_ID, {
    user_id: undefined,
  });

  window.gtag('set', 'user_properties', {
    raksul_id: undefined,
  });
}

/**
 * カスタムイベントを送信
 *
 * @param eventName - イベント名
 * @param eventParams - イベントパラメータ
 */
export function trackEvent(
  eventName: string,
  eventParams?: Record<string, unknown>
): void {
  if (!isGtagAvailable()) {
    return;
  }

  window.gtag('event', eventName, eventParams);
}
